import React, { useState } from "react";
import {
    Box,
    Input,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody,
    InputGroup,
    InputLeftElement,
    InputProps,
} from "@chakra-ui/react";
import { SketchPicker } from "react-color";

interface AppColorPickerProps extends Omit<InputProps, "onChange" | "value"> {
    value?: string;
    onChange?: (hexColor: string) => void;
}

export const AppColorPicker: React.FC<AppColorPickerProps> = ({
    value,
    onChange,
    ...props
}) => {
    const [color, setColor] = useState(value);

    const handleChange = (updatedColor) => {
        setColor(updatedColor.hex);
        if (onChange) {
            onChange(updatedColor.hex);
        }
    };

    return (
        <Popover placement="bottom-start" closeOnBlur={true}>
            <PopoverTrigger>
                <Box w="full">
                    <InputGroup cursor="pointer">
                        <InputLeftElement pointerEvents="none">
                            <Box
                                w="20px"
                                h="20px"
                                borderRadius="md"
                                bg={color}
                                boxShadow="inner"
                                border="1px solid"
                                borderColor="gray.200"
                            />
                        </InputLeftElement>
                        <Input
                            readOnly
                            value={color?.toUpperCase()}
                            pl="44px"
                            cursor="pointer"
                            {...props}
                        />
                    </InputGroup>
                </Box>
            </PopoverTrigger>

            <PopoverContent
                w="auto"
                p={0}
                border="none"
                _focus={{ boxShadow: "none" }}
            >
                <PopoverBody p={0}>
                    <SketchPicker
                        color={color}
                        onChange={handleChange}
                        disableAlpha={true}
                    />
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
};
